var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hardRefresh
      ? _c(
          "div",
          { staticClass: "main-content" },
          [
            _c("div", { staticClass: "card" }, [
              !_vm.extraOptions?.hide?.newOrderHeader
                ? _c("div", { staticClass: "card-header" }, [
                    _c("h5", [
                      _vm._v("Новая заявка\n          "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info",
                          attrs: { type: "button" },
                          on: { click: _vm.initiateOrder },
                        },
                        [_vm._v("сбросить")]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.savedOrderId
                      ? _c("p", [
                          _vm._v("Заявка "),
                          _c("strong", [_vm._v(_vm._s(_vm.savedOrderId))]),
                          _vm._v(" создана"),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c("SelectProjectCity", {
                        ref: "ProjectCitySelect",
                        attrs: {
                          customData: {
                            disableProjectSelect:
                              _vm.extraOptions?.disable?.projectSelect,
                          },
                          onUpdate: (data) => this.updateLocality(data),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [_c("SelectClient", { ref: "clientData" })],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.outsourceStore
              ? [
                  _c("div", { staticClass: "card mb-1" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("NewOutsourceOrder", {
                          attrs: {
                            clearOutsourceStore: (drug) =>
                              _vm.clearOutsourceStore(drug),
                            clientData: {
                              client: _vm.$refs.clientData.client,
                              phones: _vm.$refs.clientData.phones,
                            },
                            companyId: _vm.outsourceStore,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.outsourceStore
              ? [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-8" },
                          [
                            _vm.$editNewOrder.site_id
                              ? [
                                  _vm._l(
                                    _vm.drugsInOrder,
                                    function (drug, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: drug.id,
                                          staticClass: "drugSelected",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(drug?.id) +
                                              "\n                  "
                                          ),
                                          _c("DrugSelect", {
                                            ref: "SelectedDrug",
                                            refInFor: true,
                                            attrs: {
                                              selectedDrug: drug,
                                              searchType: "1",
                                              onSelect: (d) =>
                                                _vm.updateDrugData(d, index),
                                              updateDeliveryDate:
                                                _vm.checkDeliveryDate,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.sendDrugMessage
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "send_drug_btn_block",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-outline-info btn-xs",
                                                      on: {
                                                        click: () =>
                                                          _vm.sendDrugMessage(
                                                            _vm.drugsInOrder[
                                                              index
                                                            ]
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Отправить\n                      препарат в чат\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "drugSelected" },
                                    [
                                      _c("DrugSelect", {
                                        ref: "newDrug",
                                        attrs: {
                                          searchType: "1",
                                          onSelect: (d) =>
                                            _vm.updateDrugData(
                                              d,
                                              _vm.drugsInOrder.length
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : [
                                  _c("h4", [
                                    _vm._v(
                                      "Выберите сначала проект для выбора препаратов"
                                    ),
                                  ]),
                                ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("OrderPriceDetails", {
                              ref: "OrderPriceDetails",
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [_c("ReserveOrder", { ref: "ReserveOrder" })],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.deliveryDateWarning
                          ? _c(
                              "div",
                              [
                                _c("RecommendedDeliveryDate", {
                                  attrs: {
                                    deliveryDate:
                                      _vm.$refs.DeliveryData?.deliveryDate,
                                    cityId: _vm.currentLocality.city_id,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("DeliveryData", {
                          ref: "DeliveryData",
                          attrs: { checkDeliveryDate: _vm.checkDeliveryDate },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [_c("CommentBlock", { ref: "commentBlock" })], 1),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body flex justify-content-between" },
                      [
                        _c("div"),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("LoadingButton", {
                              attrs: {
                                title: "Клиента не устраивает срок доставки",
                                className: "btn btn-outline-warning",
                                loading: _vm.loadingBtn,
                                onClick: () =>
                                  _vm.saveOrder(false, false, false, true),
                              },
                            }),
                            _vm._v(" "),
                            _c("LoadingButton", {
                              attrs: {
                                title: "Отметить заявку как спрос",
                                className: "btn btn-outline-info",
                                loading: _vm.loadingBtn,
                                onClick: () => _vm.saveOrder(true),
                              },
                            }),
                            _vm._v(" "),
                            _vm.allowToPassDelivery
                              ? [
                                  _c("LoadingButton", {
                                    attrs: {
                                      title:
                                        "Создать заявку<br>и передать на МЛ",
                                      className: "btn btn-success",
                                      color: _vm.$constants.SUCCESS_COLOR,
                                      loading: _vm.loadingBtn,
                                      onClick: () => _vm.saveOrder(false, true),
                                    },
                                  }),
                                ]
                              : [
                                  !_vm.$editNewOrder.id &&
                                  _vm.extraOptions?.savePreOrder
                                    ? _c("LoadingButton", {
                                        attrs: {
                                          title:
                                            "Создать предварительную заявку",
                                          className: "btn btn-outline-success",
                                          color: "white",
                                          loading: _vm.loadingBtn,
                                          onClick: () =>
                                            _vm.saveOrder(false, false, true),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("LoadingButton", {
                                    attrs: {
                                      title: "Создать заявку",
                                      className: "btn btn-success",
                                      color: "white",
                                      loading: _vm.loadingBtn,
                                      onClick: () => _vm.saveOrder(),
                                    },
                                  }),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Клиент")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Поиск препаратов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Препараты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Доставка")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }